module.exports = __webpack_public_path__ + "static/media/congrats-gift.633a958b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/congrats-gift.svg
// module id = 1453
// module chunks = 46